
export class Module
{
id: number;
module: string;
}